import type { Coords } from 'google-map-react'
import Image from 'next/image'
import React from 'react'

import { AbsoluteDiv } from 'elements/layout/AbsoluteDiv'
import { Text } from 'elements/text/Text'

import { GMapDivChild } from 'modules/community/pages/CommunityPage/GoogleMapSection/SimpleMarker'

export type TClusterMarkerProps = {
  pointCount: number
  nbPoints: number
} & Coords

export const ClusterMarker: TFC<TClusterMarkerProps> = ({ lat, lng, pointCount, nbPoints }) => (
  <GMapDivChild
    lat={lat}
    lng={lng}
    w={`${35 + (pointCount / nbPoints) * 40}px`}
    h={`${35 + (pointCount / nbPoints) * 40}px`}
  >
    <Image src="/img/map/cluster.svg" height="100%" width="100%" alt="cluster" />
    <AbsoluteDiv top bottom right left align="middleCenter">
      <Text bold color="white">
        {pointCount}
      </Text>
    </AbsoluteDiv>
  </GMapDivChild>
)
